module.exports = __webpack_public_path__ + "static/media/background-zero-cigarro.f39a6edf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/background-zero-cigarro.jpg
// module id = 100
// module chunks = 0